module.exports = __webpack_public_path__ + "media/images/social-icons/email-white-364b681bd6f31b934cedef1d5736ec9d.svg";